@if (avatarConfig()?.type === 'avatar') {
  <div class="avatar-src"
       [style.width.px]="size()" [style.height.px]="size()"
       [style.background-image]="backgroundImage()"></div>
} @else {
  <div class="avatar-src"
       [style.width.px]="size()" [style.height.px]="size()"
       [ngStyle]="{'background-color': avatarConfig()?.src || 'var(--atlas-color-primary)'}">
    {{ nameFirstLetter() }}
  </div>
}
